import { useEffect, useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ImportJob, ImportJobs } from './ImportJobs';
import { ReviewSources } from './ReviewSources';

export function ImportHotelCodes({ onBusyChange }: { onBusyChange?(busy: boolean): void }) {
  const { t } = useTranslation();
  const [job, setJob] = useState<ImportJob | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    onBusyChange?.(busy);
    return () => onBusyChange?.(false);
  }, [busy, onBusyChange]);
  const [code, setCode] = useState('');
  return job ? (
    <Stack spacing={2} sx={{ my: 3 }}>
      <Typography variant="h5">{t('hotelCodeImport.review')}</Typography>
      <Typography>
        {t(job.connector === 'hotelbeds' ? 'hotelCodeImport.direct' : 'hotelCodeImport.intermediary')} ·{' '}
        {job.connector_account_id}
        {job.access && ` / ${job.access}`} · {job.job_id} · {job.status}
      </Typography>
      <Alert severity="info">{t('hotelCodeImport.reviewHelp')}</Alert>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {(job.criteria.hotel_codes as string[]).map((value) => (
          <Button
            disabled={busy}
            key={value}
            variant={code === value ? 'contained' : 'outlined'}
            onClick={() => setCode(value)}
          >
            {value}
          </Button>
        ))}
      </Stack>
      {code && (
        <ReviewSources
          onBusyChange={setBusy}
          key={`${job.job_id}:${code}`}
          scope={{ connector: job.connector, account: job.connector_account_id, access: job.access, code }}
        />
      )}
      <Button
        disabled={busy}
        onClick={() => {
          setJob(null);
          setCode('');
        }}
      >
        {t('hotelCodeImport.back')}
      </Button>
    </Stack>
  ) : (
    <ImportJobs
      codesOnly
      onBusyChange={setBusy}
      onReview={(next) => {
        setJob(next);
        setCode('');
      }}
    />
  );
}
